<app-lfsa-card-v2 [innTemplate]="enviarTemplate" [innTemplateButton]="innTemplateButton" [titulo]="'Envio de Productos Perfor'" [modulo]="'IO-Industrias'" [tituloCard]="'Lista de registros'" *ngIf="!mostrarFormulario && !mostrarFormularioRasp">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="procesar()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          NUEVO
        </a>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <div class="row col-md-12 animated fadeInRight">
    <!--<h2 class="container float-left"> Buscar </h2>-->

    <div class="container">
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class = "row">
          <div class="form-group col-12 col-md-6">
            <app-lfsa-combo-box (change)="getLineaPlanta()" [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="planta"
              [control]="formulario.get('planta')" [label]="'Planta'" [id]="'planta'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-12 col-md-6">
            <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="''" (change)="selecionLinea()"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbLinea" formControlName="linea"
              [control]="formulario.get('linea')" [label]="'Línea'" [id]="'linea'">
            </app-lfsa-combo-box>
          </div>
        </div>


        <div class = "row">
          <div class="form-group col-12 col-md-6">
            <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'" (change)="selecionLinea()"
                            [control]="formulario.get('fechaFabricaIni') | formControl" [placeholder]="'Fecha Fabricación Inicio'"
                            [label]="'Fecha de Fabricación Inicio'" [type]="'date'"
                            [id]="'fechaFabricaIni'" formControlName="fechaFabricaIni" >
            </app-lfsa-input>
          </div>
          <div class="form-group col-12 col-md-6">
            <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [claseLabel]="'letrasDefault'" (change)="selecionLinea()"
                            [control]="formulario.get('fechaFabricaFin') | formControl" [placeholder]="'Fecha Fabricación Fin'"
                            [label]="'Fecha de Fabricación Fin'" [type]="'date'"
                            [id]="'fechaFabricaFin'" formControlName="fechaFabricaFin" >
            </app-lfsa-input>
          </div>
        </div>

      </form>
      <hr />
      <div class="row">
        <div class="form-group col-md-12">
          &nbsp;
          <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
            (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>

      </div>
      <br>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
              No existen ordenes de procesos pendientes por solicitar.
            </div>
            <ag-grid-angular *ngIf="!listaVacia"
              #agGrid class="{{tvcModulo.agGrid.class}}"
              [ngStyle]="tvcModulo.agGrid.style" id="{{tvcModulo.agGrid.id}}"
              [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
              [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
              [paginationPageSize]="tvcModulo.agGrid.paginacion">
            </ag-grid-angular>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label>&nbsp;</label>
          <button (click)="procesarComplexCabaceras()" [disabled]="loading" class="btn btn-success btn-block"><i class="fa fa-upload"
              aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Parametrice contenido del producto para el PLC'" [idButton]="'abrirModal'"
  [idOpen]="'Modal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formularioCustom" novalidate class="form-group">
    <div class="row">

      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [control]="formularioCustom.get('idMaterial') | formControl"
                            [id]="'idMaterial'"
                            [label]="'ID Material*'" [mostrarImg]="false" [placeholder]="'Id Material'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="idMaterial" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <!--<div class="form-group col-12 col-md-2">
        <label>&nbsp;</label>
        <button (click)="buscar()" [tooltip]="'Buscar Material'"
          class="btn btn-success btn-block"><i class="fa fa-search" aria-hidden="true"></i></button>
      </div>-->
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [control]="formularioCustom.get('descMaterial') | formControl"
                            [id]="'descMaterial'"
                            [label]="'Nombre Material'" [isReadOnly]="true"  [mostrarImg]="false" [placeholder]="'Nombre Material'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="descMaterial">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('pesoMax') | formControl"
                            [id]="'pesoMax'"
                            [label]="'Peso Máximo'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="pesoMax" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('pesoMin') | formControl"
                            [id]="'pesoMin'"
                            [label]="'Peso Mínimo'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="pesoMin" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('peso') | formControl"
                            [id]="'peso'"
                            [label]="'Peso'" [mostrarImg]="false" [placeholder]="'0.0'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="peso" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('pesoEmbalaje') | formControl"
                            [id]="'pesoEmbalaje'"
                            [label]="'Peso Embalaje'" [mostrarImg]="false" [placeholder]="'10'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="pesoEmbalaje" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('alturaCaja') | formControl"
                            [id]="'alturaCaja'"
                            [label]="'Altura Caja'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="alturaCaja" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('retardoRechazo') | formControl"
                            [id]="'retardoRechazo'"
                            [label]="'Retardo de Rechazo'" [mostrarImg]="false" [placeholder]="'10'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="retardoRechazo" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('confNsensor') | formControl"
                            [id]="'confNsensor'"
                            [label]="'CONF N SENSOR'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="confNsensor" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('fechaOrden') | formControl"
                            [id]="'fechaOrden'" (change)="changeFechaOrden()"
                            [label]="'FECHA FABRICACIÓN '" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaOrden">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('ordenProd') | formControl"
                            [id]="'ordenProd'"
                            [label]="'Orden Prod.'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="ordenProd" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('ean14') | formControl"
                            [id]="'ean14'"
                            [label]="'EAN14'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="ean14" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('fechaCaduca') | formControl"
                            [id]="'fechaCaduca'" (change)="changeFechaCaducidad()"
                            [label]="'FECHA CADUCIDAD'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaCaduca">
        </app-lfsa-input>
      </div>
      <div class="form-group col-4 col-md-4">
        <app-lfsa-input [control]="formularioCustom.get('lote') | formControl"
                            [id]="'lote'"
                            [label]="'Lote'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="lote"
                            [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [control]="formularioCustom.get('ean128') | formControl"
                            [id]="'ean128'"
                            [label]="'EAN128'" [mostrarImg]="false"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="ean128" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div class="form-group col-2 col-md-2">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habCodEan14" formControlName="habCodEan14" [attr.disabled]="true">
          <label class="form-check-label" for="flexSwitchCheckDefault">Hab. Código EAN14</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-2">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habCodEan128" formControlName="habCodEan128">
          <label class="form-check-label" for="habCodEan128">Hab. Código EAN128</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-2">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habMenor" formControlName="habMenor">
          <label class="form-check-label" for="habMenor">Hab. Peso Menor</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-2">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habMayor" formControlName="habMayor">
          <label class="form-check-label" for="habMayor">Hab. Peso Mayor</label>
        </div>
      </div>
      <div class="form-group col-2 col-md-2">
        <label>&nbsp;</label><br>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="habAlt" formControlName="habAlt">
          <label class="form-check-label" for="habAlt">Hab. AltCaja</label>
        </div>
      </div>
      <div [class]="'col-md-2'">
        <div>
          <label>&nbsp;</label><br>
          <button  class="btn btn-success btn-block"  (click)="refrescarEan()" >
            <i class="fa fa-retweet" aria-hidden="true"></i></button>
        </div>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCustom.invalid" (click)="guardar()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="'Buscar Orden de Proceso'"
                  [tituloCard]="'Buscar Orden'" [titulo]="'Selecionar orden de Proceso'">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <div class="row col-md-12 animated fadeInRight">
    <h2 class="container float-left"> Buscar </h2>
    <hr />
    <div class="container">

      <div class="row">
        <div class="form-group col-md-12">
          &nbsp;
          <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarModal" id="quickFilter "
            (keyup)="onQuickFilterChangedModal() " #quickFilter />
        </div>

      </div>

      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loadingModal"></app-lfsa-loading-v2>
          <div *ngIf="!loadingModal">
            <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVaciaModal">
              No existen ordenes de procesos pendientes por solicitar.
            </div>
            <ag-grid-angular *ngIf="!listaVaciaModal"
              #agGrid class="{{tvcModulo.agGrid.class}}"
              [ngStyle]="tvcModulo.agGrid.style" id="{{tvcModulo.agGrid.id}}"
              [frameworkComponents]="frameworkComponentsModal " [columnDefs]="columnDefsModal" [rowSelection]="rowSelectionModal"
              [rowData]="rowDataModal" (gridReady)="onGridReadyModal($event)" [pagination]="true"
              [paginationPageSize]="tvcModulo.agGrid.paginacion">
            </ag-grid-angular>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label>&nbsp;</label>
          <button (click)="acciones('regresarCompose')" class="btn btn-danger btn-block"><i class="fa fa-arrow-left"
              aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
